import React, {
    useCallback, useEffect, useRef, useState,
} from 'react';

import './style.scss';
import Spinner from 'react-bootstrap/Spinner';
import { connect, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { bannedWords, showImageCounter, showVideoCounter } from '../../utils/helper';
import BundleMedia from '../Messenger/bundle-media';
import SingleMedia from '../Messenger/single-media';
import {
    getChatGallery,
    setChatGalleryActiveMessage,
    setChatGalleryFilter,
    setChatGalleryHasMore,
    setChatGalleryMessages,
    setShowChatGallery,
} from '../../../redux/actions/chatGallery';
import CloseButton from '../CloseButton';
import MediaContainer from "../MediaContainer";

const ChatGallery = ({
    user,
    isLoading,
    hasMore,
    messages,
    activeMessage,
    show,
    source,
    filter,
    pu = null,
    showCreditCardForm,
}) => {
    const dispatch = useDispatch();
    const perPage = 15;
    const [currentPage, setCurrentPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [paidItem, setPaidItem] = useState(null);
    const [filteredMessages, setFilteredMessages] = useState([]);

    useEffect(() => {
        dispatch(setChatGalleryHasMore(true));

        const params = {
            per_page: perPage,
            page: 1,
            reset: true,
            filter: 'purchased',
        };

        if (source === 'sidebar') {
            params.filter = 'purchased';
        }

        if (source !== 'sidebar' && pu !== null) {
            params.from = pu.id;
            params.filter = filter;
        }

        dispatch(getChatGallery(params));
        setCurrentPage(1);
    }, [filter]);

    const observer = useRef();
    const lastMediaElementRef = useCallback((node) => {
        if (isLoading) return;
        if (observer.current) {
            observer.current.disconnect();
        }

        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasMore) {
                setCurrentPage((currentPage) => currentPage + 1);
            }
        });

        if (node) observer.current.observe(node);
        return () => {
            observer.current.disconnect();
        };
    }, [isLoading, hasMore]);

    useEffect(() => {
        if (show) {
            const modal = document.querySelector('.modal');

            // document.body.style.overflow = "hidden";
            if (modal) {
                modal.style.overflow = 'hidden';
            }
        } else {
            // document.body.style.overflow = "auto";
        }

        return () => {
            // document.body.style.overflow = "auto";
        };
    }, [show]);

    useEffect(() => {

        const params = {
            per_page: perPage,
            page: currentPage,
            source: source,
        };

        if (source !== 'sidebar' && pu !== null) {
            params.from = pu.id;
            params.filter = filter;
        }

        if (source === 'sidebar') {
            params.filter = 'purchased';
        }

        dispatch(getChatGallery(params));
    }, [currentPage]);

    const isBundle = (message) => (message.is_bundle === 1 ? 'media-item__bundle' : '');

    const handleBackToSidebar = () => {
        dispatch(setShowChatGallery(false));
        dispatch(setChatGalleryFilter('all'));
    };

    const filterGallery = (selected) => {
        dispatch(setChatGalleryFilter(selected));
    };

    const viewMessage = (message) => {
        setShowModal(true);
        dispatch(setShowChatGallery(true));
        dispatch(setChatGalleryActiveMessage(message));
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const freePreview = (message) => {
        return message.medias && message.medias.length > 0 && message.medias[0].free_preview;
    };

    useEffect(() => {
        if (paidItem && Object.keys(paidItem).length > 0) {
            let tmp = [...messages];
            const index = tmp.findIndex(t => t.id == paidItem.id);

            if (index >= 0) {
                tmp[index] = paidItem;
            }

            dispatch(setChatGalleryMessages([...tmp]));
            setPaidItem(null);
        }
    }, [paidItem]);

    useEffect(() => {
        let mounted = true;

        let updatedMessages = filteredMessages.map((message) => {
            if (message.id === activeMessage.id) {
                return activeMessage;
            }

            return message;
        });

        setFilteredMessages(updatedMessages);

        return (() => {
            return mounted = false;
        });
    }, [activeMessage]);


    useEffect(() => {
        setFilteredMessages(messages);
    }, [messages]);

    return (
        <>
            {
                (source !== 'sidebar') && <div className="chat-gallery-header">
                    <div>
                        <div
                            className="chat-gallery-back-btn back-btn um-message-hide um-tip-e"
                            onClick={handleBackToSidebar}
                        >
                            <i className="fa-regular fa-chevron-left" />
                        </div>
                        <div className="active-user-name">
                            <div className="current-user">
                                <div className="title" style={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center' }}>Chat Gallery</div>
                            </div>
                        </div>
                    </div>
                    <div className="chat-gallery-filter-container">
                        <ul>
                            <li key={`all-tab`}>
                                <span
                                    onClick={(e) => filterGallery('all')}
                                    data-title="all"
                                    className={`${filter === 'all' ? 'active' : ''}`}
                                >
                                    All
                                </span>
                            </li>
                            <li key={`purchased-tab`}>
                                <span
                                    onClick={(e) => filterGallery('purchased')}
                                    data-title="purchased"
                                    className={`${filter === 'purchased' ? 'active' : ''}`}
                                >
                                    Purchased
                                </span>
                            </li>
                            <li key={`locked-tab`}>
                                <span
                                    onClick={(e) => filterGallery('locked')}
                                    data-title="locked"
                                    className={`${filter === 'locked' ? 'active' : ''}`}
                                >
                                    Locked
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            }
            <div className="chat-gallery-container media-items-container">
                {
                    showModal && !showCreditCardForm
                        ? <Modal
                            show={showModal}
                            onHide={handleClose}
                            className='chat-gallery-media-modal'
                        >
                            <Modal.Header className={'chat-gallery-modal-header'} style={{ minHeight: '40px' }}>
                                <CloseButton
                                    className="close"
                                    onClick={handleClose}
                                    style={{ position: 'absolute', top: 0, right: '12px' }}
                                />
                                <div
                                    className={'message-caption'}
                                    style={{ marginTop: '30px' }}
                                    dangerouslySetInnerHTML={{ __html: bannedWords(activeMessage.message) }}
                                />
                            </Modal.Header>
                            <Modal.Body
                                className={'chat-gallery-modal-body'}
                            >
                                <MediaContainer message={activeMessage} />
                            </Modal.Body>
                        </Modal>
                        : null
                }
                {
                    !isLoading && filteredMessages.length <= 0
                        ? <div style={{ width: '100%', textAlign: 'center' }}>No Messages Purchased</div>
                        : null
                }
                {
                    filteredMessages.length > 0 && filteredMessages.map((message, index) => {
                        if (messages.length === index + 1) {
                            return <div
                                ref={lastMediaElementRef}
                                className={`media-item ${isBundle(message)}`}
                                key={`${message.id}-${index}`}
                                onClick={(e) => viewMessage(message)}
                            >
                                <div className="media-item__icon media-stats">
                                    {showImageCounter(message.total_images)}
                                    {showVideoCounter(message.total_videos)}
                                </div>
                                {
                                    freePreview(message)
                                        ? <div className="su-free-preview__label">Free Preview</div>
                                        : null
                                }
                                {
                                    (message.medias && message.medias.length >= 2) ? <BundleMedia message={message} /> : <SingleMedia message={message} />
                                }
                            </div>;
                        } else {
                            return <div
                                className={`media-item ${isBundle(message)}`}
                                key={`${message.id}-${index}`}
                                onClick={(e) => viewMessage(message)}
                            >
                                <div className="media-item__icon media-stats">
                                    {showImageCounter(message.total_images)}
                                    {showVideoCounter(message.total_videos)}
                                </div>
                                {
                                    message.medias && message.medias.length > 0 && message.medias[0].free_preview == 1
                                        ? <div className="su-free-preview__label">Free Preview</div>
                                        : null
                                }
                                {
                                    (message.medias && message.medias.length >= 2) ? <BundleMedia message={message} /> : <SingleMedia message={message} />
                                }
                            </div>;
                        }
                    })
                }
                {
                    hasMore
                        ? (
                            <div className="text-center p4" style={{ display: 'block', width: '100%' }}>
                                <Spinner size="md" animation="border" variant="primary" />
                            </div>
                        )
                        : null
                }
            </div>
        </>
    );
};

function mapStateToProps(state) {
    return {
        show: state.chatGallery.show,
        isLoading: state.chatGallery.isLoading,
        hasMore: state.chatGallery.hasMore,
        messages: state.chatGallery.messages,
        activeMessage: state.chatGallery.activeMessage,
        filter: state.chatGallery.filter,
        showChatGallery: state.chatGallery.showChatGallery,
        activeConv: state.message.activeConv,
        source: state.chatGallery.source,
        showCreditCardForm: state.privaGlobal.creditCardForm.show
    };
}

export default connect(mapStateToProps)(ChatGallery);
